import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  search: {
    width: 304,
  },
  dropdown: {
    width: 149,
    float: "right",
  },
}));

export default styles;
